import React, { useState } from "react";
import axios from "axios";
import "./style.scss";

export default function Hospitality({ active = true, formLocation = "" }) {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [location, setLocation] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");

  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  function clearState() {
    setName("");
    setPhone("");
    setEmail("");
    setLocation("");
    setSubject("");
    setMessage("");
    setSubmitting(false);
    setErrors({});
  }

  const [success, setSuccess] = useState(false);

  function handleNameChange(e) {
    setName(e.target.value);
    setErrors({ ...errors, name: undefined });
  }
  function handleEmailChange(e) {
    setEmail(e.target.value);
    setErrors({ ...errors, email: undefined });
  }
  function handlePhoneChange(e) {
    setPhone(e.target.value);
    setErrors({ ...errors, phone: undefined });
  }
  function handleLocationChange(e) {
    setLocation(e.target.value);
    setErrors({ ...errors, location: undefined });
  }
  function handleSubjectChange(e) {
    setSubject(e.target.value);
    setErrors({ ...errors, subject: undefined });
  }
  function handleMessageChange(e) {
    setMessage(e.target.value);
    setErrors({ ...errors, message: undefined });
  }

  async function onFormSubmit(e) {
    e.preventDefault();

    setSubmitting(true);

    if (name === "") {
      setErrors({ name: "Name is required!" });
      setSubmitting(false);

      return;
    }

    if (email === "") {
      setErrors({ email: "Email is required!" });
      setSubmitting(false);

      return;
    }

    if (phone === "") {
      setErrors({ phone: "Phone is required!" });
      setSubmitting(false);

      return;
    }

    if (location === "") {
      setErrors({ location: "Location is required!" });
      setSubmitting(false);

      return;
    }

    const data = {
      name,
      email,
      phone,
      location,
      subject,
      message,
    };

    try {
      const res = await axios.post(
        "https://eclipsemattress.in/api/public/index.php/hospitality",
        data
      );
      // console.log(res.data);
      setSuccess(true);
      clearState();

      setSubmitting(false);
      window.location = "/hospitality-thankyou/";
      //   setTimeout(() => {
      //     setSuccess(false);
      //   }, 5000);
    } catch (e) {
      setSubmitting(false);

      if (e.response) {
        console.log(e.response.data);
      }
    }
  }

  return (
    <form
      onSubmit={onFormSubmit}
      className={`connect__form ${active && "connect__form--active"}`}
    >
      <label className="connect__form__label">Your Name*</label>
      <input
        onChange={handleNameChange}
        value={name}
        name="name"
        type="text"
        className="connect__form__input"
      ></input>

      <label className="connect__form__label">Your Email*</label>
      <input
        className="connect__form__input"
        onChange={handleEmailChange}
        value={email}
        name="email"
        type="email"
      ></input>

      <label className="connect__form__label">Your Phone Number*</label>
      <input
        onChange={handlePhoneChange}
        value={phone}
        name="phone"
        type="text"
        className="connect__form__input"
      ></input>

      <label className="connect__form__label">Location*</label>
      <input
        onChange={handleLocationChange}
        value={location}
        name="location"
        type="text"
        className="connect__form__input"
      ></input>

      <label className="connect__form__label">Subject</label>
      <input
        onChange={handleSubjectChange}
        value={subject}
        name="subject"
        type="text"
        className="connect__form__input"
      ></input>

      <label className="connect__form__label">Message</label>
      <textarea
        onChange={handleMessageChange}
        value={message}
        name="message"
        type="text"
        className="connect__form__textarea"
      ></textarea>

      <button className="connect__form__submit" disabled={submitting}>
        {!submitting ? "SUBMIT" : "SUBMITTING..."}
      </button>

      {errors.name && <div className="connect__error">{errors.name}</div>}
      {errors.email && <div className="connect__error">{errors.email}</div>}
      {errors.phone && <div className="connect__error">{errors.phone}</div>}
      {errors.location && (
        <div className="connect__error">{errors.location}</div>
      )}

      {success && (
        <div className="connect__success">
          Thankyou. Your response has been recorded.
        </div>
      )}
    </form>
  );
}
